import React from 'react';
import { Box, Typography } from '@mui/material';

interface IProps {
  title: string;
  count: number;
  onClick: () => void;
}

const LeadActionCounter = ({ title, count, onClick }: IProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        bgcolor: 'white',
        p: 2,
        width: '100%',
        maxWidth: { sm: '100%', md: '200px' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      className="no-print"
    >
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '18px',
          lineHeight: '20px',
          pb: 1,
        }}
      >
        {title}
      </Typography>
      <Typography
        color="error"
        variant="h3"
        fontWeight="bold"
        textAlign="center"
      >
        {count}
      </Typography>
    </Box>
  );
};

export default LeadActionCounter;
